






















































import Vue from 'vue';
import Component from 'vue-class-component';
import HomeScreenPreview from './homescreenPreview/HomeScreenPreview.vue';
import ConversationPreview from './conversationPreview/ConversationPreview.vue';
import WebAssistantLauncher from './WebAssistantLauncher.vue';
import { Prop } from 'vue-property-decorator';
import ColourService from '@/shared/services/color';
import { HomescreenAppInitViewModel, TypicalResponseTimeOptions } from '../models';
import { ConversationMessage } from '@/features/webassistant/models/conversation-message';

@Component({
	components: { HomeScreenPreview, ConversationPreview, WebAssistantLauncher }
})
export default class WebAssistantPreview extends Vue {
	@Prop() public brandColour: string;
	@Prop() public outboundMessageColour: string;
	@Prop() public actionColour: string;
	@Prop() public headerText: string;
	@Prop() public homescreenImageUrl: string;
	@Prop() public greetingText: string;
	@Prop() public introductionText: string;
	@Prop() public typicalResponseTime: number;
	@Prop() public displayLauncher: boolean;
	@Prop() public messages: ConversationMessage[];
	@Prop() public isOpen: boolean;
	@Prop({ default: 'homescreen' }) public activeView: 'homescreen' | 'conversation';
	@Prop() public disableInteraction: boolean;
	@Prop({ default: true }) public readonlyApps: string;

	@Prop() public homescreenApps: HomescreenAppInitViewModel[];

	get typicalResponseTimeString() {
		if (this.typicalResponseTime === 0) {
			return 'Web Assistant';
		}
		return `We typically reply ${TypicalResponseTimeOptions[this.typicalResponseTime].label.toLowerCase()}`;
	}

	public getContrastingBrandColour() {
		return ColourService.getContrastingColour(this.brandColour);
	}
}
